// SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>
//
// SPDX-License-Identifier: MPL-2.0

import { writable } from 'svelte/store';
import { get } from 'svelte/store';
import { TranscriptionJob } from './TranscriptionJobs.js';
import { clearTranscriptionMediaFiles, removeTranscriptionMediaFile } from './TranscriptionMediaFileStore.js';

const local_storage_jobs = 'transcriptionJobs';

/**
 * Create a Svelte store for reactivity and persistent storage of transaction jobs
 */
function createTranscriptionJobsStore() {
  const stored = localStorage.getItem(local_storage_jobs);
  const initial = stored ? JSON.parse(stored).map(TranscriptionJob.fromJSON) : [];
  const { subscribe, set, update } = writable(initial);

  // Save every change automatically in local storage
  subscribe((jobs) => {
    localStorage.setItem(local_storage_jobs, JSON.stringify(jobs));
  });

  return {
    subscribe,
    update,

    addTranscriptionJob(new_job) {
      update((jobs) => [new_job, ...jobs.filter((job) => job.getJobId() !== new_job.getJobId())]);
    },

    removeTranscriptionJob(jobId) {
      removeTranscriptionMediaFile(jobId);
      update((jobs) => jobs.filter((j) => j.getJobId() !== jobId));
    },

    removeFailedTranscriptionJobs() {
      update((jobs) => {
        for (const job of jobs) {
          if (job.hasError()) {
            removeTranscriptionMediaFile(job.getJobId());
          }
        }
        return jobs.filter((job) => !job.hasError());
      });
    },

    updateJob(updatedJob) {
      update((jobs) => jobs.map((j) => (j.getJobId() === updatedJob.getJobId() ? updatedJob : j)));
    },

    getJobById(jobId) {
      const jobs = get({ subscribe }); // Zugriff auf den aktuellen Wert
      return jobs.find((job) => job.getJobId() === jobId);
    },

    reset() {
      clearTranscriptionMediaFiles();
      set([]);
    },
  };
}

export const TranscriptionJobsStore = createTranscriptionJobsStore();
